// extracted by mini-css-extract-plugin
module.exports = {"root":"k_pJ","wrapper":"k_pK","image":"k_pL h_dq h_ds h_dQ","crop":"k_pM","round":"k_pN","fixedHeight":"k_pP"};